import { InfoOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

interface Props {
    title?: string;
    size?: number;
    color?: string;
}

const InfoTooltip = ({ title, size = 14, color = 'secondary.main' }: Props) => {
    if (!title) return null;

    return (
        <Tooltip title={title} arrow placement="top" enterTouchDelay={0} leaveTouchDelay={6000}>
            <InfoOutlined
                tabIndex={0}
                aria-label={title}
                sx={{ color, cursor: 'pointer', fontSize: size, mx: 0.4, verticalAlign: 'middle' }}
            />
        </Tooltip>
    );
};

export default InfoTooltip;
